import { trustHTML } from "@ember/template";
import DTooltip from "discourse/float-kit/components/d-tooltip";

const triggers = {
  mobile: ["hover"],
  desktop: ["hover"],
};

<template>
  <DTooltip @triggers={{triggers}} @untriggers={{triggers}} @placement="bottom">
    <:trigger>
      {{yield}}
    </:trigger>
    <:content>
      <div class="d-tooltip-content">
        {{trustHTML @outletArgs.topic.excerpt}}
      </div>
    </:content>
  </DTooltip>
</template>
